import React from "react";

import { PrimaryButton } from "../../simple-buttons/simple-buttons";
import { SVGInfoIcon } from "../../svg-animated/svg-animated";
import { FormContext } from "../../forms";
import DocumentStatus from "./document-status";

const DocumentCheckIncomplete = ({ context }: { context?: FormContext }) => {
    return (
        <DocumentStatus
            icon={<SVGInfoIcon />}
            headingText="We&apos;re still checking your documents"
            subheadingText="Don&apos;t let that hold you up though. 
            You can continue with your application and tap **Submit** when you&apos;re done."
            paragraphText="We&apos;ll be in touch if we need anything else."
            button={<PrimaryButton onClick={() => context?.gotoNextPage()} text="Continue" />}
        />
    )
};

export default DocumentCheckIncomplete;
